/* Kilt set menu: size fields appear only after the item they belong to is chosen (and are then required). */
(function () {
  document.querySelectorAll('[data-a1-setmenu]').forEach(function (menu) {
    function sync() {
      menu.querySelectorAll('[data-a1-set-parent]').forEach(function (child) {
        var on = child.getAttribute('data-a1-set-parent').split(',').some(function (key) {
          var parent = menu.querySelector('[data-a1-set-group="' + key + '"] select');
          return parent && parent.value !== '';
        });
        var sel = child.querySelector('select');
        child.hidden = !on;
        sel.disabled = !on;
        sel.required = on;
        if (!on) sel.value = '';
      });
    }
    function summaries() {
      menu.querySelectorAll('.a1-itemgroup').forEach(function (g) {
        var sel = g.querySelector('select');
        var out = g.querySelector('[data-a1-summary]');
        if (!sel || !out) return;
        var txt = sel.value === '' ? 'None' : sel.value.replace(/ \(\+\$\d+\)$/, '');
        out.textContent = txt;
      });
    }
    menu.addEventListener('change', function () { sync(); summaries(); });
    sync();
    summaries();
  });
})();
